import { Link } from "react-router-dom";
import { Phone, Mail, KeyRound } from "lucide-react";
import { Crown } from "@/components/brand";
import { BRAND } from "@/constants/states";

export const Footer = () => (
  <footer
    data-testid="footer-section"
    className="relative pt-24 pb-12 px-4 sm:px-8 bg-[#030C15] border-t border-[#C9A24B]/20 overflow-hidden"
  >
    <p
      aria-hidden="true"
      className="absolute -bottom-8 left-1/2 -translate-x-1/2 font-display font-black text-[13vw] leading-none tracking-tight text-[#FBF8F2]/[0.035] whitespace-nowrap pointer-events-none select-none"
    >
      COLLISION QUEENS
    </p>
    <div className="relative max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <div className="flex items-center gap-3">
            <Crown className="w-10 h-8 crown-glow" />
            <div>
              <p data-testid="footer-brand-title" className="font-display font-bold tracking-[0.14em] text-[#FBF8F2] text-lg">
                COLLISION QUEENS <span className="text-[#0E7C86]">CONNECT</span>
              </p>
              <p className="font-data text-[10px] tracking-[0.3em] uppercase text-[#8EA3B0] mt-1">
                Accident &amp; Injury Resource Network
              </p>
            </div>
          </div>
          <p className="mt-5 font-script text-2xl text-[#E5C378]">Trusted connections when they matter most.</p>
        </div>
        <div className="flex flex-col gap-4">
          <a data-testid="footer-phone-link" href={BRAND.phoneHref} className="flex items-center gap-3 text-[#D4DFE6] hover:text-[#E8C87A] transition-colors duration-300">
            <Phone className="w-4 h-4 text-[#C9A24B]" /> {BRAND.phone}
          </a>
          <a data-testid="footer-email-link" href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-[#D4DFE6] hover:text-[#E8C87A] transition-colors duration-300">
            <Mail className="w-4 h-4 text-[#C9A24B]" /> {BRAND.email}
          </a>
          <Link data-testid="footer-admin-link" to="/admin" className="flex items-center gap-3 text-[#8EA3B0] hover:text-[#E8C87A] text-sm transition-colors duration-300">
            <KeyRound className="w-4 h-4" /> Admin Portal
          </Link>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-[#C9A24B]/15">
        <p data-testid="footer-disclaimer" className="text-[11px] leading-relaxed text-[#8EA3B0] max-w-3xl">
          Collision Queens Connect is an independent accident resource and referral network. We are not a law
          firm or medical practice. Professional services are provided by licensed independent affiliates.
        </p>
        <div className="mt-5 flex flex-col sm:flex-row justify-between gap-3 text-[11px] text-[#8EA3B0]">
          <p>&copy; {new Date().getFullYear()} Collision Queens Connect. All rights reserved.</p>
          <p className="font-data tracking-[0.2em] uppercase">Women-Founded &bull; Trusted &bull; Compassionate &bull; Connected &bull; Empowering</p>
        </div>
      </div>
    </div>
  </footer>
);
